import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row items-center justify-end" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QDatePicker',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const birthDate = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    modelValue: _unref(birthDate),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null))
  }, _ctx.$attrs, {
    mask: "date",
    rules: ['date'],
    "lazy-rules": "",
    "fill-mask": "#",
    class: "q-mb-sm"
  }), {
    append: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: "event",
        class: "cursor-pointer"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_popup_proxy, {
            ref: "qDateProxy",
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_date, {
                modelValue: _unref(birthDate),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null)),
                "today-btn": "",
                "default-view": "Years"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createVNode(_component_q_btn, {
                      label: "Close",
                      color: "primary",
                      flat: ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue"]))
}
}

})